import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import BookingForm from '../BookingForm';
import './ServicePages.css';
import SEO from '../SEO.js';

const MotherBabyCare = () => {
  const [showBookingForm, setShowBookingForm] = useState(false);

  const handleBookNow = () => {
    setShowBookingForm(true);
  };

  const handleCloseBooking = () => {
    setShowBookingForm(false);
    // Fix button color after form closes
    const buttons = document.querySelectorAll('.book-now-hero-btn, .cta-button, .sidebar-book-btn');
    buttons.forEach(button => {
      button.style.backgroundColor = 'var(--primary-color)';
      button.style.border = 'none';
      button.style.color = 'var(--white-color)';
    });
  };

  const benefits = [
    'Professional care in the comfort of home',
    'Reduced stress for new mothers',
    'Personalized care plans for mother and baby',
    'Expert guidance for first-time parents',
    'Support for breastfeeding and infant care',
    'Monitoring of mother and baby\'s health'
  ];

  const careServices = [
    {
      name: 'Prenatal Care',
      description: 'Support and monitoring during pregnancy, including nutrition guidance and birth preparation.'
    },
    {
      name: 'Postnatal Care',
      description: 'Recovery support for new mothers, including wound care, lactation support, and emotional wellbeing.'
    },
    {
      name: 'Newborn Care',
      description: 'Expert care for newborns, including feeding, bathing, health monitoring, and developmental support.'
    },
    {
      name: 'Parent Education',
      description: 'Guidance and training for new parents on baby care, safety, and developmental milestones.'
    }
  ];

  return (
    <div className="service-page mother-baby-page">
      <SEO 
        title="Mother and Baby Care Services in Bangalore"
        description="Specialized mother and baby care services in Bangalore. Postnatal care, newborn care, breastfeeding support, and expert guidance for new mothers."
        keywords="mother and baby care Bangalore, postnatal care at home, newborn care services, baby massage at home, nanny for newborn"
      />
      <div className="service-hero">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} md={12}>
              <div className="service-hero-content">
                <h1>Mother & Baby Care Services</h1>
                <p>Specialized care for mothers and newborns in your home</p>
                <Button className="book-now-hero-btn" onClick={handleBookNow}>
                  Book Appointment
                </Button>
              </div>
            </Col>
            <Col lg={6} md={12}>
              <div className="service-hero-image">
                <img src="/images/baby-care.jpg" alt="Mother and Baby Care Services" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="service-content">
        <Row>
          <Col lg={8} md={12}>
            <div className="service-description">
              <h2>Comprehensive Mother & Baby Care at Home</h2>
              <p>
                Our Mother & Baby Care services provide specialized support for expectant mothers, new mothers, and 
                newborns in the comfort of your home. Our team of experienced maternal and child health professionals 
                offers comprehensive care that addresses the unique needs of both mother and baby during this important time.
              </p>
              <p>
                From prenatal support to postnatal recovery and newborn care, our services are designed to ensure the 
                health and wellbeing of both mother and baby. We provide not only physical care but also emotional 
                support and practical guidance to help new parents navigate the challenges of early parenthood with confidence.
              </p>
              
              <h3>Our Mother & Baby Care Services</h3>
              <Row className="treatment-cards">
                {careServices.map((service, index) => (
                  <Col md={6} key={index} className="mb-4">
                    <Card className="treatment-card h-100">
                      <Card.Body>
                        <Card.Title>{service.name}</Card.Title>
                        <Card.Text>{service.description}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
              
              <h3 className="mt-4">What Our Mother & Baby Care Includes</h3>
              
            </div>
            <ul className="service-list">
                <li>Prenatal health monitoring and education</li>
                <li>Postnatal recovery support</li>
                <li>Breastfeeding guidance and support</li>
                <li>Newborn care and health monitoring</li>
                <li>Baby bathing and hygiene demonstrations</li>
                <li>Nutritional advice for mother and baby</li>
                <li>Sleep training guidance</li>
                <li>Emotional support for new parents</li>
              </ul>
          </Col>
          
          <Col lg={4} md={12}>
            <div className="service-sidebar">
              <Card className="benefits-card">
                <Card.Header as="h5">Benefits of Home Mother & Baby Care</Card.Header>
                <Card.Body>
                  <ul className="benefits-list">
                    {benefits.map((benefit, index) => (
                      <li key={index}>{benefit}</li>
                    ))}
                  </ul>
                  <div className="d-grid gap-2 mt-4">
                    <Button variant="primary" onClick={handleBookNow} className="sidebar-book-btn">
                      Book Care Services
                    </Button>
                  </div>
                </Card.Body>
              </Card>
              
              <Card className="why-choose-card mt-4">
                <Card.Header as="h5">Why Choose Our Mother & Baby Care?</Card.Header>
                <Card.Body>
                  <ul className="why-choose-list">
                    <li>Experienced maternal and child health professionals</li>
                    <li>Personalized care plans for each family</li>
                    <li>Continuous support throughout the journey</li>
                    <li>Evidence-based practices and advice</li>
                    <li>Flexible scheduling to meet your needs</li>
                  </ul>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md={12}>
            <div className="cta-section text-center">
              <h3>Need Support for Mother & Baby?</h3>
              <p>Our specialized team is ready to provide expert care for you and your baby at home.</p>
              <Button size="lg" onClick={handleBookNow} className="cta-button">
                Schedule a Consultation
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
      
      <BookingForm 
        show={showBookingForm} 
        handleClose={handleCloseBooking} 
        defaultService="Mother & Baby Care"
      />
    </div>
  );
};

export default MotherBabyCare;
